import { createContext } from 'react';
import { getDefaults, setDefaults } from './defaults.js';
import { getI18n, setI18n } from './i18nInstance.js';
import { initReactI18next } from './initReactI18next.js';
export { getDefaults, setDefaults, getI18n, setI18n, initReactI18next };
export const I18nContext = createContext();
export class ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(namespaces) {
    namespaces.forEach(ns => {
      if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
export const composeInitialProps = ForComponent => async ctx => {
  var _await$ForComponent$g, _ForComponent$getInit;
  const componentsInitialProps = (_await$ForComponent$g = await ((_ForComponent$getInit = ForComponent.getInitialProps) === null || _ForComponent$getInit === void 0 ? void 0 : _ForComponent$getInit.call(ForComponent, ctx))) !== null && _await$ForComponent$g !== void 0 ? _await$ForComponent$g : {};
  const i18nInitialProps = getInitialProps();
  return {
    ...componentsInitialProps,
    ...i18nInitialProps
  };
};
export const getInitialProps = () => {
  var _i18n$reportNamespace, _i18n$reportNamespace2;
  const i18n = getI18n();
  const namespaces = (_i18n$reportNamespace = (_i18n$reportNamespace2 = i18n.reportNamespaces) === null || _i18n$reportNamespace2 === void 0 ? void 0 : _i18n$reportNamespace2.getUsedNamespaces()) !== null && _i18n$reportNamespace !== void 0 ? _i18n$reportNamespace : [];
  const ret = {};
  const initialI18nStore = {};
  i18n.languages.forEach(l => {
    initialI18nStore[l] = {};
    namespaces.forEach(ns => {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
};